import styles from "./searchFilters.module.css";
import { CategoryDt, OptionDt } from "../../../Models/SearchModel";
import { useContext, useEffect, useRef, useState } from "react";
import { SearchContext } from "../../../Store/Search.store";
import AlternativeTo from "../../../components/SearchFilter/AlternativeToFilter";
import SectorFilter from "../../../components/SearchFilter/SecotrFilter";
import UseFilter from "../../../components/SearchFilter/UseFilter";
import AlternativeLevelFilter from "../../../components/SearchFilter/AlternativeLevelFilter";
import SuplierFilter from "../../../components/SearchFilter/SuplierFilter";
import CertificationsFilter from "../../../components/SearchFilter/CertificationsFilter";
import ActiveSearchFilterButton from "./ActiveSearchFilterButton";
import { closeIcon } from "../../../assets/icons";
import OrderBy from "./OrderBy";

export default function SearchFilters() {
    const {searchData, setSearchData} = useContext(SearchContext);
    const [activeAlternativeToCategories, setActiveAlternativeToCategories] = useState<OptionDt[]>([]);
    const [activeSector, setActiveSector] = useState<OptionDt[]>([]);
    const [activeUse, setActiveUse] = useState<OptionDt[]>([]);
    const [activeAlternativeLevel, setActiveAlternativeLevel] = useState<OptionDt[]>([]);
    const [activeSuplier, setActiveSuplier] = useState<OptionDt[]>([]);
    const [activeCertifications, setActiveCertifications] = useState<OptionDt[]>([]);
    const [mobileOpen, setMobileOpen] = useState<boolean>(false);
    const [activeFilter, setActiveFilter] = useState<{sds: boolean, tds: boolean, bio: boolean, popular: boolean}>({sds: false, tds: false, bio: false, popular: false});
    const sdsRef = useRef<HTMLInputElement>(null);
    const tdsRef = useRef<HTMLInputElement>(null);
    const bioRef = useRef<HTMLInputElement>(null);
    const popularRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        document.querySelector("body")?.addEventListener("click", (e) => {
            const element = e.target as HTMLElement;
            const expandedFilter = element.closest('.filter');
            if(expandedFilter == null){
                setSearchData((prevState) => ({
                    ...prevState,
                    openFilter: 0,
                }));
            }
        });
    }, []);

    const newSearchData = (alternativeToCategories: OptionDt[], sectorCategories: OptionDt[], useCategories: OptionDt[], alternativeLevel: OptionDt[], Supliers: OptionDt[], certificationCategories: OptionDt[]) => {
        let newItems = alternativeToCategories.length > 0 ? searchData.initialSearchItems.filter(item => 
            item.alternativeToCategories.some(category => 
                alternativeToCategories.some(f => f.id === category.id && f.isSelected)
            )
        ) : searchData.initialSearchItems;

        newItems = sectorCategories.length > 0 ? newItems.filter(item =>
            item.sectorCategories.some(category => 
                sectorCategories.some(f => f.id === category.id && f.isSelected)
            )
        ) : newItems;

        newItems = useCategories.length > 0 ? newItems.filter(item =>
            item.useCategories.some(category => 
                useCategories.some(f => f.id === category.id && f.isSelected)
            )
        ) : newItems;

        newItems = alternativeLevel.length > 0 ? newItems.filter(item =>
                alternativeLevel.some((f: OptionDt) => f.id === item.alternativeLevel && f.isSelected)
        ) : newItems;

        newItems = Supliers.length > 0 ? newItems.filter(item =>
            Supliers.some((f: OptionDt) => f.id === item.companyId && f.isSelected)
        ) : newItems;

        newItems = certificationCategories.length > 0 ? newItems.filter(item =>
            item.certificationCategories.some(category => 
                certificationCategories.some(f => f.id === category.id  && f.isSelected)
            )
        ) : newItems;

        return newItems;
    };

    const newFilterData = (filter: OptionDt[], items: CategoryDt[], activeFilter: OptionDt[]) => {
        let updatedFilter = filter.map(filterCategory => {
            const matchingItemsCount = items.filter(item => item.id === filterCategory.id).length;
            return {
                ...filterCategory,
                isSelected: filterCategory.id === activeFilter.find(f => f.id === filterCategory.id)?.id,
                hits: matchingItemsCount
            };
        });
        return updatedFilter.sort((a, b) => a.name.localeCompare(b.name));
    }

    const oneFilterActive = (filter: OptionDt[], activeFilter: OptionDt[]) => {
        let updatedFilter = filter.map(filterCategory => {
            return {
                ...filterCategory,
                isSelected: filterCategory.id === activeFilter.find(f => f.id === filterCategory.id)?.id,
                hits: filterCategory.hits ?? 0
            };
        });
        return updatedFilter.sort((a, b) => a.name.localeCompare(b.name));
    }

    const handleFilterChange = (filter: OptionDt[], filterOrder: number, currentActiveFilters: {sds: boolean, tds: boolean, bio: boolean, popular: boolean} | null = null) => {
        let alternativeToCategories = activeAlternativeToCategories;
        let sector = activeSector;
        let use = activeUse;
        let alternativeLevel = activeAlternativeLevel;
        let suplier = activeSuplier;
        let certifications = activeCertifications;
        
        switch (filterOrder) {
            case 1:
                alternativeToCategories = filter;
                setActiveAlternativeToCategories(filter);
                break;
            case 2:
                sector = filter;
                setActiveSector(filter);
                break;
            case 3:
                use = filter;
                setActiveUse(filter);
                break;
            case 4:
                alternativeLevel = filter;
                setActiveAlternativeLevel(filter);
                break;
            case 5:
                suplier = filter;
                setActiveSuplier(filter);
                break;
            case 6:
                certifications = filter;
                setActiveCertifications(filter);
                break;
            default:
                break;
        }
        
        let newItems = newSearchData(alternativeToCategories, sector, use, alternativeLevel, suplier, certifications);

        let newAlternativeToCategories = newFilterData(searchData.initialFilters.alternativeToCategories, newItems.flatMap(item => item.alternativeToCategories), alternativeToCategories);
        let newSector = newFilterData(searchData.initialFilters.sectorCategories, newItems.flatMap(item => item.sectorCategories), sector);
        let newUse = newFilterData(searchData.initialFilters.useCategories, newItems.flatMap(item => item.useCategories), use);
        let newAlternativeLevel = newFilterData(searchData.initialFilters.alternativeLevels, newItems.flatMap(item => { return {id: item.alternativeLevel, name: item.alternativeLevel.toString()} as CategoryDt}), alternativeLevel);
        let newSuplier = newFilterData(searchData.initialFilters.suppliers, newItems.flatMap(item => { return {id: item.companyId, name: item.companyName} as CategoryDt}), suplier);
        let newCertifications = newFilterData(searchData.initialFilters.certificationsCategories, newItems.flatMap(item => item.certificationCategories), certifications);

        const filters = [alternativeToCategories, sector, use, alternativeLevel, suplier, certifications];
        const nonEmptyFilters = filters.filter(filter => filter !== undefined && filter !== null && filter.length > 0);
        if (nonEmptyFilters.length == 1) {
            const nonEmptyFilterIndex = filters.indexOf(nonEmptyFilters[0]);
            switch (nonEmptyFilterIndex) {
                case 0:
                    newAlternativeToCategories = oneFilterActive(searchData.initialFilters.alternativeToCategories, alternativeToCategories);
                    break;
                case 1:
                    newSector = oneFilterActive(searchData.initialFilters.sectorCategories, sector);
                    break;
                case 2:
                    newUse = oneFilterActive(searchData.initialFilters.useCategories, use);
                    break;
                case 3:
                    newAlternativeLevel = oneFilterActive(searchData.initialFilters.alternativeLevels, alternativeLevel);
                    break;
                case 4:
                    newSuplier = oneFilterActive(searchData.initialFilters.suppliers, suplier);
                    break;
                case 5:
                    newCertifications = oneFilterActive(searchData.initialFilters.certificationsCategories, certifications);
                    break;
                default:
            }
        }

        const activeFilters = currentActiveFilters ?? activeFilter;
        switch (true) {
            case activeFilters.sds && activeFilters.tds && activeFilters.bio && activeFilters.popular:
                newItems = newItems.filter(item => item.isBioBased && item.isPopular && item.hasSds && item.hasTds);
              break;
            case activeFilters.sds && activeFilters.tds && activeFilters.bio:
                newItems = newItems.filter(item => item.isBioBased && item.hasSds && item.hasTds);
              break;
            case activeFilters.sds && activeFilters.tds && activeFilters.popular:
                newItems = newItems.filter(item => item.isPopular && item.hasSds && item.hasTds);
              break;
            case activeFilters.sds && activeFilters.bio && activeFilters.popular:
                newItems = newItems.filter(item => item.isBioBased && item.isPopular && item.hasSds);
              break;
            case activeFilters.tds && activeFilters.bio && activeFilters.popular:
              newItems = newItems.filter(item => item.isBioBased && item.isPopular && item.hasTds);
              break;
            case activeFilters.sds && activeFilters.tds:
              newItems = newItems.filter(item => item.hasSds && item.hasTds);
              break;
            case activeFilters.sds && activeFilters.bio:
              newItems = newItems.filter(item => item.isBioBased && item.hasSds);
              break;
            case activeFilters.sds && activeFilters.popular:
              newItems = newItems.filter(item => item.isPopular && item.hasSds);
              break;
            case activeFilters.tds && activeFilters.bio:
              newItems = newItems.filter(item => item.isBioBased && item.hasTds);
              break;
            case activeFilters.tds && activeFilters.popular:
              newItems = newItems.filter(item => item.isPopular && item.hasTds);
              break;
            case activeFilters.bio && activeFilters.popular:
             newItems =  newItems.filter(item => item.isBioBased && item.isPopular);
              break;
            case activeFilters.sds:
             newItems =  newItems.filter(item => item.hasSds);
              break;
            case activeFilters.tds:
             newItems =  newItems.filter(item => item.hasTds);
              break;
            case activeFilters.bio:
             newItems =  newItems.filter(item => item.isBioBased);
              break;
            case activeFilters.popular:
             newItems =  newItems.filter(item => item.isPopular);
              break;            default:
              break;
            };

        setSearchData(prevState => ({
            ...prevState,
            currentPage: 1, // Reset to page 1 when filters change
            data: {
                ...prevState.data,
                items: newItems,
                filters: {
                    alternativeToCategories: newAlternativeToCategories,
                    sectorCategories: newSector,
                    useCategories: newUse,
                    alternativeLevels: newAlternativeLevel,
                    suppliers: newSuplier,
                    certificationsCategories: newCertifications,
                }
            }
        }));
    }
    
    const clearAllFilters = () => {
        setActiveAlternativeToCategories([]);
        setActiveSector([]);
        setActiveUse([]);
        setActiveAlternativeLevel([]);
        setActiveSuplier([]);
        setActiveCertifications([]);
        setSearchData(prevState => ({
          ...prevState,
          currentPage: 1, // Reset to page 1 when clearing all filters
          data: {
            ...prevState.data,
            items: prevState.initialSearchItems,
            filters: prevState.initialFilters
          }
        }));

        clearCheckBoxFilters();
    }

    const handleOpenMobileFilter = () => {
        document.querySelector("body")?.classList.toggle("no-scroll");
        setMobileOpen(!mobileOpen);
    }
    
    const clearCheckBoxFilters = () => {
        sdsRef.current!.checked = false;
        tdsRef.current!.checked = false;
        bioRef.current!.checked = false;
        popularRef.current!.checked = false;
        setActiveFilter({sds: false, tds: false, bio: false, popular: false});
    }

    const checkBoxHandler = (filter: string) =>{
        let activeFilters = activeFilter;
        switch (filter) {
          case "sds":
            activeFilters = {...activeFilter, sds: !activeFilter.sds};
            break;
          case "tds":
            activeFilters = {...activeFilter, tds: !activeFilter.tds};
            break;
          case "bio":
            activeFilters = {...activeFilter, bio: !activeFilter.bio};
            break;
          case "popular":
            activeFilters = {...activeFilter, popular: !activeFilter.popular};
            break;
          default:
            break;
        }
        setActiveFilter(activeFilters);

        handleFilterChange([], 10, activeFilters);
    }

return (
    <>
        <div className="desktop">
            <div className={styles.filter_container}>
                <AlternativeTo filterItems={searchData.data.filters.alternativeToCategories} callBack={handleFilterChange}/>
                <SectorFilter filterItems={searchData.data.filters.sectorCategories} callBack={handleFilterChange}/>
                <UseFilter  filterItems={searchData.data.filters.useCategories} callBack={handleFilterChange}/>
                <AlternativeLevelFilter filterItems={searchData.data.filters.alternativeLevels} callBack={handleFilterChange}/>
                <SuplierFilter filterItems={searchData.data.filters.suppliers} callBack={handleFilterChange}/>
                <CertificationsFilter filterItems={searchData.data.filters.certificationsCategories} callBack={handleFilterChange}/>
            </div>
            <ActiveSearchFilterButton clearAllFilters={clearAllFilters} clearFilter={handleFilterChange}/>
        </div>
        <hr className={styles.desktop_hr}/>

        <div className={`${styles.sortfilter} desktop`}>
            <div className={styles.button_container}>
                <div className={`${styles.filter_background} ${sdsRef.current?.checked == true ? styles.isChecked : ""}`}>
                    <label htmlFor="sds-available" className={styles.text}>SDS available</label>
                    <input ref={sdsRef} type="checkbox" name="sort-filter" id="sds-available" value="sds-available" onChange={() => checkBoxHandler("sds")}/>
                </div>
                <div className={`${styles.filter_background} ${tdsRef.current?.checked == true ? styles.isChecked : ""}`}>
                    <label htmlFor='tds-available' className={styles.text}>TDS available</label>
                    <input ref={tdsRef} type="checkbox" name="sort-filter" id="tds-available" value="tds-available" onChange={() => checkBoxHandler("tds")}/>
                </div>
                <div className={`${styles.filter_background} ${bioRef.current?.checked == true ? styles.isChecked : ""}`}>
                    <label htmlFor='bio-based' className={styles.text}>Bio-based</label>
                    <input ref={bioRef} type="checkbox" name="sort-filter" id="bio-based" value="bio-based" onChange={() => checkBoxHandler("bio")}/>
                </div>
                <div className={`${styles.filter_background} ${popularRef.current?.checked == true ? styles.isChecked : ""}`}>
                    <label htmlFor='popular-alternative' className={styles.text}>Popular alternative</label>
                    <input ref={popularRef} type="checkbox" name="sort-filter" id="popular-alternative" value="popular-alternative" onChange={() => checkBoxHandler("popular")}/>
                </div>
            </div>
              <OrderBy text='Sort by:'/>
        </div>
        <div className="mobile">
            <div style={{display: "inline-block"}}>
                <button className="button button_black" onClick={() => handleOpenMobileFilter()}>Filter</button>
            </div>
            <div className={`${styles.backCover} ${mobileOpen ? styles.open : ""}`} onClick={() => setMobileOpen(!mobileOpen)}>
            </div>
            <div className={`${styles.menu} ${mobileOpen ? styles.open : ""}`}>
                <div className={styles.filter_header}>
                    <span>Filter</span>
                    <button onClick={() => handleOpenMobileFilter()} aria-label="close filter menu">{closeIcon}</button>
                </div>
                <div className={styles.mobile_filter}>
                    <AlternativeTo filterItems={searchData.data.filters.alternativeToCategories} callBack={handleFilterChange}/>
                    <SectorFilter filterItems={searchData.data.filters.sectorCategories} callBack={handleFilterChange}/>
                    <UseFilter  filterItems={searchData.data.filters.useCategories} callBack={handleFilterChange}/>
                    <AlternativeLevelFilter filterItems={searchData.data.filters.alternativeLevels} callBack={handleFilterChange}/>
                    <SuplierFilter filterItems={searchData.data.filters.suppliers} callBack={handleFilterChange}/>
                    <CertificationsFilter filterItems={searchData.data.filters.certificationsCategories} callBack={handleFilterChange}/>
                </div>
            </div>
          <OrderBy text='Sort by'/>
        </div>
    </>
);
}